<template>
  <Modal name="LINK_SERVICE_PROVIDER_CUSTOMER" :title="title" actions>
    <template #body>
      <!-- It is commented out because we might use it in the customer list as well -->
      <!-- <HServiceProviderSelect v-if="!unlink" v-model="serviceProvider" :disabled="isLoadingBoard" density="compact" /> -->
      <HCustomerSelect v-if="!unlink" v-model="selectedCustomer" :disabled="isLoadingBoard" density="compact" />
      <LinkDataComponent :customer="selectedCustomer" :service-provider="serviceProvider" :unlink="unlink" />
    </template>
    <template #actions>
      <div class="d-flex gap-1">
        <v-btn @click="closeModal('LINK_SERVICE_PROVIDER_CUSTOMER')" :disabled="isLoadingBoard" elevation="0" color="grey" text>
          {{ $t('create.cancel') }}
        </v-btn>
        <v-btn @click="handleLinkAction" :loading="isLoadingBoard" :disabled="!hasSelectedServiceProvider" color="primary" elevation="0">
          <span class="body-1"> {{ title }} </span>
        </v-btn>
      </div>
    </template>
  </Modal>
</template>

<script>
import Modal from '@/components/app/Modal.vue'
import HCustomerSelect from '../../app/HCustomerSelect'
// import HServiceProviderSelect from '@/components/app/HServiceProviderSelect'
import LinkDataComponent from '@/components/customer/modals/fragments/LinkDataComponent'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ModalLinkServiceProviderCustomer',

  props: {
    id: {
      type: String,
      required: false,
    },

    customer: {
      type: Object,
    },

    unlink: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    Modal,
    HCustomerSelect,
    // HServiceProviderSelect,
    LinkDataComponent,
  },

  computed: {
    ...mapGetters(['isLoadingBoard', 'serviceProvider']),

    hasSelectedServiceProvider() {
      return this.serviceProvider !== null
    },

    customerId() {
      return this.selectedCustomer.id
    },

    title() {
      return this.unlink
        ? this.$t('serviceProviders.action.unlink')
        : this.$t('serviceProviders.action.link')
    }
  },

  methods: {
    ...mapActions(['linkServiceProviderCustomer', 'unlinkServiceProviderCustomer', 'closeModal']),

    handleLinkAction() {
      const payload = {
        real_estate_id: this.customerId,
        service_provider_id: this.serviceProvider.id,
      }

      if (this.unlink) {
        this.unlinkServiceProviderCustomer({ id: this.id })
      } else {
        this.linkServiceProviderCustomer(payload)
      }
    },
  },

  watch: {
    customer(customer) {
      this.selectedCustomer = customer
    },
  },

  data() {
    return {
      isLoading: false,
      selectedCustomer: null,
    }
  },
}
</script>
